export default __webpack_public_path__ + "assets/timeRange.c7e02068.svg";